import React from 'react'
import HtmlContent from '../HtmlContent'
import Section from '../Section'
import Title from '../Title'
import style from './styles/detail_head.module.scss'

interface IProps {
  image: string[] | null | undefined
  date: string
  title: string
  content: string | null | undefined
  children?: any
}

const DetailPageHead = ({
  image,
  date,
  title,
  content,
  children
}: IProps): React.ReactElement => {
  const slicedDate = date !== '' ? date.slice(0, 10) : ''

  return (
    <>
      {image !== undefined && image !== null
        ? (
          <img
            src={image[0]}
            width='705px'
            height='438px'
            alt=''
            className={style.detail__image}
          />
          )
        : undefined}
      <span className={style.detail__date}>{slicedDate}</span>
      <Title type='h1' theme='h2' className={style.detail__title}>
        {title}
      </Title>
      {children !== undefined ? <div>{children}</div> : null}
      <Section>
        {content !== undefined && content !== null && content !== ''
          ? (
            <HtmlContent content={content} className={style.detail__text} />
            )
          : undefined}
      </Section>
    </>
  )
}

export default DetailPageHead
